/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const UserRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.USER.INSURER_TAKER_SELECTION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/insurer-taker-selection/insurer-taker-selection.module').then(
        m => m.InsurerTakerSelectionPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.INSURER_TAKER_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/insurer-taker-data/insurer-taker-data.module').then(m => m.InsurerTakerDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.DRIVERS_INFORMATION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/drivers-information/drivers-information.module').then(m => m.DriversInformationPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.OTHER_VEHICLES.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/user/other-vehicles/other-vehicles.module').then(m => m.OtherVehiclesPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.FLENSBURG_POINTS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/flensburg-points/flensburg-points.module').then(m => m.FlensburgPointsPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.PREVIOUS_INSURANCE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/previous-insurance/previous-insurance.module').then(m => m.PreviousInsurancePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.CLASS_OF_LIABILITY.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/class-of-liability/class-of-liability.module').then(m => m.ClassOfLiabilityPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.REPORT_CLAIMS.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/user/report-claims/report-claims.module').then(m => m.ReportClaimsPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.NEW_QUOTATION.USER.PERIOD_PREVIOUS_INSURANCE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/user/period-previous-insurance/period-previous-insurance.module').then(
        m => m.PeriodPreviousInsurancePageModule
      ),
    canActivate: [NavigationGuard],
  },
];
